<!-- <div>
<div class="w-100">
    <table class="table table-bordered	table-hover">
        <thead>
            <tr>
                <input type="text" class="form-control form-control-lg"/>
                <th>روابط سريعه</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let fav of favoLinks">
                    <td>
                        <i class="fa fa-trash" title="delete" (click)="onFavourite(fav,3)"></i>
                         {{fav.sortView}} - {{fav.nameAr}}

                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div> -->

<div class="container-fluid">

  <div class="title-tab-step text-center">
    روابط سريعه
    <!-- <i *ngIf="parentId != 0" class="fa fa-plus fa-1x icons-style" aria-hidden="true" placement="left" ngbTooltip="{{ 'ADD' | translate }}"
        (click)="addEditRow(0)"></i> -->
  </div>
  <!--search area-->
  <div class="ui-widget-header search-area row">
    <div class="col-5">
      <input #gb class="form-control" type="text" pInputText size="30" placeholder="{{ 'FILTER' | translate }}">
    </div>
  </div>

  <div class="container-fluid p-0">
    <div class="">
      <div class="">
        <p-dataTable tableStyleClass="table table-bordered table-striped" [value]="favoLinks">
          <p-column header="{{ 'SORTVIEW' | translate }}" [sortable]="true">
            <ng-template let-row="rowData" pTemplate="options">
              <input type="number" numberonly min="1" class="form-control" class="table table-responsive" required
                [(ngModel)]="row.sortView">
            </ng-template>
          </p-column>
          <p-column field="nameAr" header="{{ 'NAMEAR' | translate }}" ></p-column>
          <p-column styleClass="col-button">
            <ng-template pTemplate="options" let-row="rowData">
              <icon-action (clicked)="ondeleteFavourite(row,3)" [appCodes]="[403]"></icon-action>
            </ng-template>
          </p-column>
        </p-dataTable>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
        <btns-ctrl #btnCtrl1 [appCodes]="[1]" (clicked)="onBtnSave($event)"></btns-ctrl>
    </div>
</div>

</div>